import { apiV1, RequestWithPagination } from 'shared';

import {
  AnswerQuizReq,
  GetLeaderboardRes,
  GetLeaderboardStatsRes,
  GetPurchaseRes,
  GetReferralsRes,
  GetTimerRes,
  UserQuizStatsRes,
} from './types';

const getTimer = () => {
  return apiV1<GetTimerRes>({
    url: '/giveaway/timer/',
    method: 'GET',
  });
};

const getReferrals = () => {
  return apiV1<GetReferralsRes>({
    url: '/giveaway/referrals/',
    method: 'GET',
  });
};

const getPurchasesInfo = () => {
  return apiV1<GetPurchaseRes>({
    url: '/giveaway/purchase/',
    method: 'GET',
  });
};

const getLeaderboardStats = () => {
  return apiV1<GetLeaderboardStatsRes>({
    url: '/giveaway/leader_board/statistics/',
    method: 'GET',
  });
};

const getLeaderboard = ({ pageNumber, pageSize }: RequestWithPagination) => {
  return apiV1<GetLeaderboardRes>({
    url: `/giveaway/leader_board/?page_number=${pageNumber}&page_size=${pageSize}`,
    method: 'GET',
  });
};

const getUserQuizStats = () => {
  return apiV1<UserQuizStatsRes>({
    url: '/giveaway/quiz/',
    method: 'GET',
  });
};

const answerQuiz = ({ data }: { data: AnswerQuizReq }) => {
  return apiV1<UserQuizStatsRes>({
    url: '/giveaway/quiz/',
    method: 'POST',
    data,
  });
};

export const giveawayApi = {
  getTimer,
  getReferrals,
  getPurchasesInfo,
  getLeaderboardStats,
  getLeaderboard,
  getUserQuizStats,
  answerQuiz,
};

export * from './types';
